<template>
  <!-- 加入会员 -->
  <div id="join_member">
      <h2>加入会员</h2>
      <div class="member_content">
        <div class="contact_us" @click="connectionClick()">
          <img src="../assets/image19.png" alt="">
          <p>联系我们</p>
        </div>
        <div class="apply_member" @click="joinMemberClick()">
          <img src="../assets/image17.png" alt="">
          <p>会员申请</p>
        </div>
        <div class="xh_about" @click="aboutClick()">
          <img src="../assets/image18.png" alt="">
          <p>协会简介</p>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'JoinMemberComponent',
  methods: {
    connectionClick(){
      window.open('https://duud.cn/app/index.php?i=767&c=entry&do=detail&m=tech_superarticle&id=324','_blank');
    },
    aboutClick() {
      window.open('https://duud.cn/app/index.php?i=767&c=entry&do=detail&m=tech_superarticle&id=226','_blank');
    },
    joinMemberClick(){
      window.open('https://duud.cn/app/index.php?i=767&c=entry&do=detail&m=tech_superarticle&id=226','_blank');
    }
  }
}
</script>
<style scoped>
@import "../style/common.css";
@import "../style/join-member.css";
</style>